import { Component, NgZone, ViewChild, ElementRef, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import moment from 'moment';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TopNavbarComponent } from '../../../app/parkifly-bookings/organizations/components/top-navbar/top-navbar.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS, DateAdapter } from '@angular/material/core';
import { NativeDateAdapter } from '@angular/material/core';
import { UpperCasePipe, CommonModule } from '@angular/common';
import { CheckboxComponent } from '../../../app/parkifly-bookings/components/checkbox/checkbox.component';
import { SelfServiceService } from '../../../app/services/self-service.service';
import { CartService } from '../../../app/services/cart.service';
import { BookingConfigService } from '../../../app/parkifly-bookings/services/booking-config.service';
import { CheckoutServices } from '../../../app/parkifly-bookings/services/checkout.service';
import { DynamicScriptLoaderService } from '../../../app/services/dynamicScriptLoader.service';
import { MatSnackBar } from '@angular/material/snack-bar';

class CustomDateAdapter extends NativeDateAdapter {
  override format(date: Date, displayFormat: Object): string {
    return moment(date).format('YYYY/MM/DD');
  }
}

const CUSTOM_DATE_FORMATS = {
  parse: { dateInput: 'YYYY/MM/DD' },
  display: { dateInput: 'YYYY/MM/DD', monthYearLabel: 'YYYY', dateA11yLabel: 'YYYY/MM/DD', monthYearA11yLabel: 'YYYY' }
};

declare var payex: any;
@Component({
  selector: 'app-drive-in-details-form',
  imports: [TopNavbarComponent, TranslocoModule, ReactiveFormsModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatInputModule, MatFormFieldModule, MatCheckboxModule, MatRadioModule, MatSelectModule, MatDatepickerModule, MatNativeDateModule, UpperCasePipe, CommonModule, CheckboxComponent, UpperCasePipe],
  templateUrl: './drive-in-details-form.component.html',
  styleUrl: './drive-in-details-form.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS }
  ]
})

export class DriveInDetailsFormComponent {

  @ViewChild('detailsSection') detailsSection!: ElementRef;
  isLoading = false;
  paymentLoadError = false;
  showbookingDetailsForm = false;
  parkingFound: boolean = false;
  wrongParking: boolean = false;
  ParkingToBeCreated: boolean = false;
  minEndDate: Date = new Date();
  maxEndDate: Date = new Date();
  isEditingRegNo = false;
  timeoutError: boolean;
  showDetailsPage: boolean = false;
  showPaymentOption: boolean = false;
  parkings: any = {};
  parkingTo: string;
  parkingFrom: string;
  orderId: string = null;
  orgId = "";
  showRegInputField: boolean = true;;
  isPaymentCompleted = false;
  payexCreditcardUrl = '';
  payexSwishUrl = '';
  payexUrl = '';
  payexSwishLoaded = false;
  selectedPayment: string | null = null;
  isDiscountCodeWrong: boolean = false;
  driveInBookingForm = {
    licensePlate: '',
    parkingFrom: '',
    parkingTo: '',
    price: '',
    parkingId: '',
    gateName: '',
    orderId: '',
    orgId: '',
    vehicleOwner: null
  };

  parkingDatesForm = new FormGroup({
    startDate: new FormControl<Date | null>(null, [Validators.required]),
    startTime: new FormControl('', [Validators.required]),
    endDate: new FormControl<Date | null>(null, [Validators.required]),
    endTime: new FormControl('', [Validators.required]),
    discount: new FormControl(''),
  });

  bookingDetailsForm = new FormGroup({
    firstName: new FormControl('', [Validators.required]),
    lastName: new FormControl('', [Validators.required]),
    phone: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    consent: new FormControl(false, [Validators.requiredTrue])
  });

  constructor(public translate: TranslocoService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private selfServiceService: SelfServiceService,
    private cartService: CartService,
    private bookingconfig: BookingConfigService,
    public checkoutService: CheckoutServices,
    private dynamicScriptLoaderService: DynamicScriptLoaderService,
    private ngZone: NgZone,
    private snackBar: MatSnackBar
  ) {
    this.bookingconfig.setOrganizationFromUrl();
  }

  ngOnInit(): void {
    const navigation = this.router.getCurrentNavigation();
    const state = navigation?.extras?.state;
    if (state) {
      this.driveInBookingForm = {
        licensePlate: state['licensePlate'],
        parkingFrom: state['parkingFrom'],
        parkingTo: state['parkingTo'],
        price: state['price'],
        parkingId: state['parkingId'],
        gateName: state['gateName'],
        orderId: state['orderId'],
        orgId: state['orgId'],
        vehicleOwner: state['vehicleOwner']
      };
      this.prefillVehicleOwnerData();
    } else {
      this.route.queryParams.subscribe(params => {
        this.driveInBookingForm = {
          licensePlate: params['l'],
          parkingFrom: params['parkingFrom'],
          parkingTo: params['parkingTo'],
          price: params['price'],
          parkingId: params['parkingId'],
          gateName: params['gateName'],
          orderId: params['orderId'],
          orgId: params['orgId'],
          vehicleOwner: params['vehicleOwner'] ? JSON.parse(params['vehicleOwner']) : null
        };
        this.prefillVehicleOwnerData();
      });
    }
    this.showParkingDatesForm();

    // Subscribe to end date and time changes for special parking IDs
    this.parkingDatesForm.controls.endDate.valueChanges.subscribe(() => {
      this.tryCheck();
    });

    this.parkingDatesForm.controls.endTime.valueChanges.subscribe(() => {
      this.tryCheck();
    });
  }

  createBooking() {
    if (this.isLoading) return;

    this.bookingDetailsForm.markAllAsTouched();

    if (!this.bookingDetailsForm.valid) {
      return;
    }

    if (!this.bookingDetailsForm.valid) {
      return;
    }

    this.isLoading = true;
    let bookingData: any = {
      orderId: this.driveInBookingForm.orderId,
      customer: {
        firstname: this.bookingDetailsForm.get('firstName')?.value,
        lastname: this.bookingDetailsForm.get('lastName')?.value,
        email: this.bookingDetailsForm.get('email')?.value,
        cellular: this.bookingDetailsForm.get('phone')?.value,
      }
    };

    // if (this.driveInBookingForm.orgId.toLowerCase() === '942ce067-7848-4441-b746-8f6eed7395bb') {
    //   bookingData.parking = {
    //     parkingId: this.driveInBookingForm.parkingId,
    //     productCode: this.parkings.productCode,
    //     carId: this.driveInBookingForm.licensePlate,
    //     parkingFrom: this.driveInBookingForm.parkingFrom,
    //     parkingTo: this.combineDateAndTime(this.parkingDatesForm.controls.endDate.value, this.parkingDatesForm.controls.endTime.value)
    //   };
    // }

    this.selfServiceService.completeDriveUpRegistration(bookingData).then((result: any) => {
      if (result.orderId) {
        this.orderId = result.orderId
        this.getOrder();
      } else {
        const message = this.translate.translate('DRIVE_IN_BOOKING.CLICK_AGAIN');
        this.snackBar.open(message, 'OK', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
      this.ParkingToBeCreated = false;
      this.showbookingDetailsForm = false;
      this.showDetailsPage = false;
      this.showPaymentOption = true;
    }).catch(() => {
      const message = this.translate.translate('DRIVE_IN_BOOKING.CLICK_AGAIN');
      this.snackBar.open(message, 'OK', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
    }).finally(() => {
      this.isLoading = false;
    });

  }

  getOrder() {
    this.paymentLoadError = false;
    this.checkoutService.getOrder(this.orderId).subscribe({
      next: (order) => {
        const paymentReference = order?.paymentReference && JSON.parse(order?.paymentReference);
        if (paymentReference != null) {
          this.loadScripts(paymentReference);
        } else {
          const message = this.translate.translate('DRIVE_IN_BOOKING.SOMETHING_WRONG');
          this.snackBar.open(message, 'OK', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      },
      error: () => {
        const message = this.translate.translate('DRIVE_IN_BOOKING.SOMETHING_WRONG');
        this.snackBar.open(message, 'OK', {
          duration: 3000,
          verticalPosition: 'top',
          horizontalPosition: 'center'
        });
      }
    });
  }

  loadScripts(paymentReference: any) {
    const cardModal = document.getElementById('swedbank-pay-seamless-view-page');
    if (cardModal) {
      cardModal.innerHTML = ''; cardModal
    }
    const viewCheckoutOp = paymentReference.operations.find(
      (op) => op.rel === 'view-checkout'
    );
    this.payexUrl = viewCheckoutOp?.href;
    this.dynamicScriptLoaderService.addScript(this.payexUrl);

    this.dynamicScriptLoaderService
      .load(this.payexUrl)
      .then(() => {
        if (typeof payex !== 'undefined') {
          payex.hostedView
            .checkout({
              container: 'swedbank-pay-seamless-view-page',
              onPaymentCompleted: (event: any) => {
                this.ngZone.run(() => {
                  this.isPaymentCompleted = true;
                });
              },
              onPaymentCancelled: (event: any) => {
                this.ngZone.run(() => {
                  this.selectedPayment = null;
                });
              }
            })
            .open();
        } else {
          this.paymentLoadError = true;
        }
      })
      .catch(error => console.error(error));
  }

  triggerConsent() {
    this.bookingDetailsForm.controls.consent.setValue(!this.bookingDetailsForm.controls.consent.value);
  }

  resetBookingDetailsForm() {
    const reg = this.bookingDetailsForm.get('registrationNumber')?.value
    this.bookingDetailsForm.reset();
    this.paymentLoadError = false;
    this.bookingDetailsForm.get('registrationNumber')?.setValue(reg);
  }

  showParkingDatesForm() {

    this.showbookingDetailsForm = true;
    this.showDetailsPage = true;

    const parkingFromDate = this.driveInBookingForm.parkingFrom ? new Date(this.driveInBookingForm.parkingFrom) : new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Stockholm' }));
    const parkingToDate = this.driveInBookingForm.parkingTo ? new Date(this.driveInBookingForm.parkingTo) : new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Stockholm' }));
    this.parkingDatesForm.patchValue({
      startDate: parkingFromDate,
      startTime: parkingFromDate.toTimeString().slice(0, 5),
      endDate: parkingToDate,
      endTime: parkingToDate.toTimeString().slice(0, 5)
    });

    // if (this.driveInBookingForm?.orgId?.toLowerCase() === '942ce067-7848-4441-b746-8f6eed7395bb') {
    //   this.parkingDatesForm.patchValue({
    //     endDate: null,
    //     endTime: null
    //   });
    // }

    setTimeout(() => {
      this.detailsSection?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 100);
  }

  combineDateAndTime(date: any, time: any): string {
    if (!time) {
      const d = new Date(date);
      return d.getFullYear() + '-' +
        String(d.getMonth() + 1).padStart(2, '0') + '-' +
        String(d.getDate()).padStart(2, '0') + 'T' +
        String(d.getHours()).padStart(2, '0') + ':' +
        String(d.getMinutes()).padStart(2, '0');
    }
    time = time.split(":")
    const combinedDate = new Date(date);
    combinedDate.setHours(parseInt(time[0]));
    combinedDate.setMinutes(parseInt(time[1]));
    combinedDate.setSeconds(0);
    combinedDate.setMilliseconds(0);
    const result = combinedDate.getFullYear() + '-' +
      String(combinedDate.getMonth() + 1).padStart(2, '0') + '-' +
      String(combinedDate.getDate()).padStart(2, '0') + 'T' +
      String(combinedDate.getHours()).padStart(2, '0') + ':' +
      String(combinedDate.getMinutes()).padStart(2, '0');
    return result;
  }

  get isContinueButtonEnabled(): boolean {
    return this.parkingDatesForm.controls.endDate.value !== null && this.parkingDatesForm.controls.endTime.value !== '';
  }



  canCheck(): boolean {
    const endDate = this.parkingDatesForm.controls.endDate.value !== null;
    const endTime = this.parkingDatesForm.controls.endTime.value !== '';
    return endDate && endTime;
  }

  tryCheck(): void {
    const isSpecialOrgId = this.driveInBookingForm.orgId === '942ce067-7848-4441-b746-8f6eed7395bb';

    if (isSpecialOrgId && this.canCheck()) {
      // this.check();
      this.getAvailableParkingsForOrganization();
    }
  }


  getAvailableParkingsForOrganization() {
    const orgId = this.driveInBookingForm.orgId;
    // const discount = this.parkingDatesForm.get('discount')?.value || "NONE";
    const parkingId = this.driveInBookingForm.parkingId;
    const periodFromDate = this.combineDateAndTime(this.parkingDatesForm.get('startDate')?.value, this.parkingDatesForm.get('startTime')?.value);
    const periodToDate = this.combineDateAndTime(this.parkingDatesForm.get('endDate')?.value, this.parkingDatesForm.get('endTime')?.value);
    this.parkingFrom = periodFromDate;
    this.parkingTo = periodToDate;
    this.cartService
      .getAvailableParkings(orgId, periodFromDate, periodToDate, 'NONE', parkingId)
      // .pipe(
      //   timeout(30000),
      //   catchError(error => {
      //     if (error.name === 'TimeoutError') {
      //       this.showDetailsPage = false;
      //       this.timeoutError = true;
      //       return of(null);
      //     }
      //     return throwError(() => error);
      //   })
      // )
      .subscribe({
        next: (parkings) => {
          this.parkings = parkings?.parkings && parkings?.parkings[0];
          if (parkings.discountCode != 'NONE') {
            this.isDiscountCodeWrong = !parkings?.parkings?.some((parking: any) => parking.discountCheckAmount > 0 || parking.discountCheckPercent > 0);
          }
          if (parkings?.parkings?.length <= 0) {
            const message = "Parking is not available for the selected date range.";
            // const message = this.translate.translate('DRIVE_IN_BOOKING.CLICK_AGAIN');
            this.snackBar.open(message, 'OK', {
              duration: 3000,
              verticalPosition: 'top',
              horizontalPosition: 'center'
            });
            // this.showDetailsPage = false;
          } else {
            this.driveInBookingForm.price = this.parkings?.totalPrice;
            // this.showDetailsPage = true;
            // setTimeout(() => {
            //   this.detailsSection?.nativeElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            // }, 100);
          }
          // this.bookingDetailsForm.controls.registrationNumber.setValue(this.driveInBookingForm?.licensePlate);
          // this.timeoutError = false;
        },
        error: () => {
          const message = this.translate.translate('DRIVE_IN_BOOKING.CLICK_AGAIN');
          this.snackBar.open(message, 'OK', {
            duration: 3000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
          });
        }
      });
  }

  // check(): void {
  //   if (this.isLoading) return;
  //   this.isLoading = true;
  //   console.log(this.driveInBookingForm.gateName)
  //   const data = {
  //     gateName: this.driveInBookingForm.gateName,
  //     parkingTo: this.combineDateAndTime(this.parkingDatesForm.controls.endDate.value, this.parkingDatesForm.controls.endTime.value)
  //   };
  //   this.selfServiceService.calculateDriveUp(data).then((result: any) => {
  //     if (result?.amountIncludeVat) {
  //       this.driveInBookingForm.price = result.amountIncludeVat;
  //     }
  //     this.isLoading = false;
  //   }).catch((error) => {
  //     console.error('Calculate drive up error:', error);
  //     this.isLoading = false;
  //   });
  // }

  prefillVehicleOwnerData() {
    if (this.driveInBookingForm.vehicleOwner) {
      const owner = this.driveInBookingForm.vehicleOwner;
      this.bookingDetailsForm.patchValue({
        firstName: owner.firstName || '',
        lastName: owner.lastName || '',
        phone: owner.phoneNumber || ''
      });
    }
  }

}
